// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1985c7e3","453":"0907cc3c","455":"edfc8665","977":"b206f3a1"}[chunkId] + ".chunk.js";
};